
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacies/main/zh-cn",
      function () {
        return require("private-next-pages/privacies/main/zh-cn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacies/main/zh-cn"])
      });
    }
  